import React from 'react';
import { guides, pillars, steps } from '../data/kit';
export function Guides() {
  return <section className="bg-sage-50 px-4 py-8 md:py-16" data-id="element-123" data-mp="6lmihhq5dkej">
      <div className="max-w-5xl mx-auto" data-id="element-124" data-mp="6k327r4hr9cr">
        <div className="text-center mb-5 md:mb-10" data-id="element-125" data-mp="bkqpq2tih828">
          <h2 className="font-serif text-[24px] md:text-[42px] font-bold text-wine tracking-tight leading-[1.12] max-w-3xl mx-auto" data-id="element-126" data-mp="bjxpzlsyzitl">
            ASÍ PASÁS DE “NO SÉ QUÉ HACER”{' '}
            <span className="text-rose-600" data-id="element-127" data-mp="laiozack2pd1">A TENER UN CAMINO CLARO PARA TRABAJARLO</span>
          </h2>
          <ol className="flex flex-wrap justify-center items-center gap-x-1.5 sm:gap-x-2 gap-y-1 mt-3 md:mt-6 text-[13px] sm:text-sm font-semibold text-rose-700" data-id="element-128" data-mp="pb2lqct7vqyn">
            {steps.map((step, i) => <li key={step} className="flex items-center gap-1.5 sm:gap-2 whitespace-nowrap" data-id="element-129" data-mp="za1wq21gfyot" data-mpi={i}>
                {i > 0 && <span className="text-ink-faint" aria-hidden="true" data-id="element-130" data-mp="2w4y2z2ylk9tj">→</span>}
                <span data-id="element-131" data-mp="312zixf0q7t0s">{step}</span>
              </li>)}
          </ol>
        </div>

        <ol className="rounded-3xl bg-white border border-sage-300 divide-y divide-sage-100" data-id="element-132" data-mp="2thb6pa2bh0ei">
          {guides.map((g, i) => <li key={g.title} className="grid grid-cols-[auto_1fr] md:grid-cols-[120px_1fr_1fr] gap-x-4 md:gap-x-5 gap-y-1 md:gap-y-2 px-4 py-4 md:p-7" data-id="element-133" data-mp="2onq5za9c9sbm" data-mpi={i}>
              <p className="font-serif text-sage-300 font-bold text-3xl md:text-5xl leading-none row-span-2 md:row-span-1" data-id="element-134" data-mp="2fn1pm8wh3fvk">
                {i + 1}
              </p>
              <div data-id="element-135" data-mp="37hdlgnfbvdpj">
                <p className="text-[10px] md:text-[11px] font-bold tracking-[0.2em] text-rose-500" data-id="element-136" data-mp="37gu4pa1eyvd3">
                  PASO {i + 1}
                </p>
                <h3 className="font-serif font-bold text-wine text-base md:text-lg leading-snug mt-0.5 md:mt-1" data-id="element-137" data-mp="2yg5ms48wgaux">
                  {g.title}
                </h3>
                <p className="font-bold text-sage-600 text-[15px] md:text-base leading-snug mt-0.5 md:mt-1.5" data-id="element-138" data-mp="1rxh71r48ekmt">
                  {g.subtitle}
                </p>
              </div>
              <p className="col-start-2 md:col-start-3 text-sm text-ink-muted leading-snug md:leading-relaxed" data-id="element-139" data-mp="1oi5uu31hpmo6">
                {g.desc}
              </p>
            </li>)}
        </ol>

        <p className="text-center mt-4 md:mt-6 text-[13px] sm:text-sm font-semibold text-rose-700" data-id="element-140" data-mp="1fgeqp2mllnwf">
          {pillars.join(' · ')}
        </p>
      </div>
    </section>;
}